import { AuthConfig, OAuthModuleConfig, OAuthStorage } from 'angular-oauth2-oidc';
import { AuthorizeService } from '../../services/authorize.service';
import { ConfigService } from 'src/env/config.service';

export function authAppInitializerFactory(_authorizeService: AuthorizeService): () => Promise<void> {
  return () => {
    return new Promise<void>((resolve, reject) => {
      resolve(_authorizeService.runInitialLoginSequence());
    });
  };
}

export function storageFactory(): OAuthStorage {
  return localStorage;
}

export function authConfigFactory(_configService: ConfigService): AuthConfig {
  return _configService.getAuthConfig();
}

export function oauthModuleConfigFactory(_configService: ConfigService): OAuthModuleConfig {
  return _configService.getOAuthModuleConfig();
}
